'use strict';
import Labels from "./labels";
import Config from "./config";

let utils = {
  debounced: {},
  getIsoDate(date) {
    if (!date || typeof (date) !== "object") return "";
    return `${date.getFullYear()}-${(this.twoDigits(date.getMonth() + 1))}-${this.twoDigits(date.getDate())}`
  },
  getIsoDateTime(date) {
    if (!date || typeof (date) !== "object") return "";
    return `${date.getFullYear()}-${(this.twoDigits(date.getMonth() + 1))}-${this.twoDigits(date.getDate())}T${this.twoDigits(date.getHours())}:${this.twoDigits(date.getMinutes())}:${this.twoDigits(date.getSeconds())}${this.offsetToTimeZone(date.getTimezoneOffset())}`;
  },
  twoDigits(x) {
    let sign = x < 0 ? "-" : "";
    x = Math.abs(x);
    if (x < 10) return `${sign}0${x}`;
    else return `${sign}${x}`;
  },
  showStatusMessage (msg, color, duration) {
    if (!msg) return;
    color = color || "green";
    duration = duration | 5000;
    let messageBox = document.createElement("div");
    messageBox.classList.add("cla-messagebox");
    messageBox.classList.add(color);
    messageBox.innerHTML = msg;
    document.body.appendChild(messageBox);
    setTimeout(() => {
      if (messageBox) {
        messageBox.style.opacity = '0';
        setTimeout(() => {
          messageBox.remove();
        }, 500);
      }
    }, duration);
  },
  offsetToTimeZone(offset) {
    if (offset === "0") return "Z";
    let intOffset = -parseInt(offset);
    return `${intOffset > 0 ? "+": ""}${this.twoDigits(Math.floor(intOffset / 60))}:${this.twoDigits(intOffset % 60)}`;
  }, 
  showLoader (element, showAtTheTop) {
    let el = typeof(element) === "string" ? document.querySelector(element) : element;
    if (!el) {
      console.warn(`Could not create loader in the element ${typeof(element)==="string" ? element : element.name}`);
      return;
    }
    let loader = document.createElement("div");
    loader.classList.add("loader");
    if (showAtTheTop) loader.classList.add("top");
    el.appendChild(loader);
    return loader;
  },
  removeLoader (loader) {
    if (!loader) return;
    if (!loader.parentNode) return;
    loader.parentNode.removeChild(loader);
  },
  debounce(label, fnc, delay) {
    if (this.debounced.hasOwnProperty(label)) {
      clearTimeout(this.debounced[label]);
    }
    this.debounced[label] = setTimeout(fnc, delay);
  }
};

export default utils;